import { createSlice } from "@reduxjs/toolkit";
import {
  getTaskdetails,
  historicalFlowCreate,
  updatehistoricalFlow,
  Resetpassword,
  deleteTask,
  getHistoricaljsondata,
  updateHistoricaljsondefaultdata,
  CreatehistoricalContracts,
  GetbufferdatafromUrl,
  CreatehistoricalContractsAddendum,
  getHistoricalDatabyId,
  getImportsList,
  getImportItemById,
  CreateBulkHistorical,
  submitFileUploadExcel,
  getTokenforGoogledrive,
  Sendfilesandfolder,
  getLegalAssociates,
  getAssignTasktoLegalAssociates,
  getReAssignTasktoLegalAssociates,
  getAllImportsItemById,
  getDistributedcontractDetails,
  unassignandReassignContractToLegalAssociate,
  getDetailsFillwithAI,
  saveCompanyPrompt,
  getBulkAssignedData,
  getBulkAssignTasktoLegalAssociates,
  getBulkReAssignTasktoLegalAssociates,
  EditPrompt,
  FindMissingContract,
  getImportsDetailsById,
  findDuplicatesContract,
  getDuplicatesContractLists,
  deleteDuplicatesContracts,
  getHistoricalDetails,
  getAddendumDetailsFillwithAI,
  ImportAddendumforHistorical,
} from "./historicalFlowAction";
import { message } from "antd";
const initialState = {
  isLoading: true,
  isCreateLoading: false,
  isSuccess: false,
  isError: false,
  isMessage: null,
  historicalTaskList: [],
  isVisible: false,
  otherFieldOfChecklist: [],
  isDrawerVisible: false,
  ispasswordVisible: false,
  ispasswordloading: false,
  ispasswordupdated: false,
  editRecord: {},
  type: "",
  ispagination: false,
  totalCount: null,
  historicalTaskPagination: {
    total: 0,
    pageSize: 20,
    defaultCurrent: 1,
    current: 1,
    sortBy: "DESC",
    showSizeChanger: true,
    search: "",
    orderBy: "createdAt",
  },
  historicalTaskPaginationbygroupById: {
    total: 0,
    pageSize: 20,
    defaultCurrent: 1,
    current: 1,
    sortBy: "DESC",
    showSizeChanger: true,
    search: "",
    orderBy: "createdAt",
  },
  otherChecklistData: [],
  selectedOtherField: {},
  isEditjsonModalVisible: false,
  EditjsonModalRecord: {},
  EditjsonModaltype: "",

  historicalformdata: [],
  isnewfieldModalVisible: false,
  collapseDataIds: 0,
  fieldcreatefrom: "",
  Companydetails: "",
  EditcollapseIds: 0,
  Templateselectedval: {},
  jsonforvariables: [],
  templateforjsonData: {},
  Generalextradetails: [],
  otherChecklistextradetailData: {},
  isFilterApplied: false,
  isFiltermodalopen: false,
  contractpdfurl: "",
  isHistoricalDatinlimit: {},
  importtype: "",
  isAddendumDrawerVisible: false,
  isHistoricalDetailViewVisible: false,
  extraRecord: {},
  isBulkLegacyImportVisible: false,
  isMetadataInfoModalVisible: false,
  ImportLists: [],
  ImportListsLoading: true,
  groupIdInfo: {},
  isCheckBulkUploadModalVisible: false,
  BulkuploadRecord: {},
  isBulkpdupLoading: false,
  isBulkjsonupLoading: false,
  ImportListPagiantion: {
    total: 0,
    pageSize: 10,
    defaultCurrent: 1,
    current: 1,
    sortBy: "DESC",
    showSizeChanger: true,
    search: "",
    orderBy: "createdAt",
  },
  googleDriveData: {},
  legalAssociatesList: [],
  isLegalAssociatesLoading: false,
  assignTasktoLegalAssociates: {},
  reAssignTasktoLegalAssociates: {},
  isReAssignTasktoLegalAssociatesLoading: false,
  isAssignTasktoLegalAssociatesLoading: false,
  isLegalAssociateModalVisible: false,
  ImportsItemByIdLists: [],
  isImportsItemByLoading: false,
  ImportsItemByIdListsPagination: {
    total: 0,
    pageSize: 20,
    defaultCurrent: 1,
    current: 1,
    sortBy: "DESC",
    showSizeChanger: true,
    search: "",
    orderBy: "createdAt",
  },
  isAssignandReassignModalVisible: false,
  assignModalType: "",
  assignModalRecord: {},
  isAssignandReassignFilterModalVisible: false,
  selectedTasksIds: [],
  isAssignFilterApplied: false,
  AssigndFilterPaginationData: {},
  distributedContractDetails: {},
  isBulkAssignModalVisible: false,
  isContentVisible: true,
  isAIpromptModalVisible: false,
  isAIpromptSubmitting: false,
  BulkAssignedData: {},
  promptRecord: "",
  isEditPromptModalVisible: false,
  isEditingprompt: false,
  isFindMissingcontractModalVisible: false,
  isFindingMissingcontract: false,
  isFindMissingContractRecord: {
    _id: "1234",
    contract_info: [
      {
        id: "1",
        parentContractDate: "November 15, 2022",
        parentContractType: "Master Service Agreement",
        party1: "ABC Services Limited",
        party2: "ProTech Consulting Private Limited",
        type: "child",
      },
      {
        id: "2",
        parentContractDate: "November 15, 2022",
        parentContractType: "Master Service Agreement",
        party1: "ABC Services Limited",
        party2: "ProTech Consulting Private Limited",
        type: "child",
      },
    ],
    contracts_processed: 2,
    errors: [
      "Callback failed: name 'missing_parents_value_matching' is not defined",
    ],
    missing_contracts: [
      {
        child_id: "1",
        description: "Missing based on value matching method",
        missing_parent:
          "Master Service Agreement November 15, 2022 ABC Services Limited vs ProTech Consulting Private Limited",
      },
      {
        child_id: "2",
        description: "Missing based on value matching method",
        missing_parent:
          "Master Service Agreement November 15, 2022 ABC Services Limited vs ProTech Consulting Private Limited",
      },
    ],
    status: "completed",
  },
  isAIprocessingModalVisible: false,
  isFindingDuplicatesContract: false,
  isRemoveDuplicatesModalVisible: false,
  duplicateContractsLists: [],
  isDuplicateContractsLoading: false,
  isDeletingDuplicates: false,
  isHistoricalDetailsLoading: false,
  parentContractDetail: {},
  isAIreferenceDrawerVisible: false,
  isImportAddendumVisible: false,
  importAddendumRecord: {},
  isAddendumImportingForHistorical: false,
};
const flowSlice = createSlice({
  name: "flow",
  initialState: initialState,
  reducers: {
    onChangeOtherData: (state, { payload }) => {
      state.otherChecklistextradetailData = payload?.record || {};
      state.otherChecklistData =
        payload?.record?.checkListData?.length > 0
          ? payload.record.checkListData
          : [];
    },
    onClickAddOtherField: (state, { payload }) => {
      state.selectedOtherField = payload.claItem;
      var updatedFields = [...state.otherFieldOfChecklist];
      updatedFields.push({
        _id: payload.claItem._id,
      });
      state.otherFieldOfChecklist = updatedFields;
    },
    onChangeNewvalueTitle: (state, { payload }) => {
      const updatedFields = [...state.otherFieldOfChecklist];
      const addOfValueIndex = updatedFields.findIndex(
        (ofItem) => ofItem._id === payload.claItem._id
      );
      updatedFields[addOfValueIndex] = {
        ...updatedFields[addOfValueIndex],
        value: payload.value,
      };
      state.otherFieldOfChecklist = updatedFields;
    },
    onChangeNewKeyTitle: (state, { payload }) => {
      const updatedFields = [...state.otherFieldOfChecklist];
      const addOfkeyIndex = updatedFields.findIndex(
        (ofItem) => ofItem._id === payload.claItem._id
      );
      updatedFields[addOfkeyIndex] = {
        ...updatedFields[addOfkeyIndex],
        label: payload.key,
      };
      state.otherFieldOfChecklist = updatedFields;
    },
    onClickAddnewOtherFieldInObject: (state, { payload }) => {
      if (!payload.onfItem.label && !payload.onfItem.value) {
        message.warn("Please enter label and its value");
      }
      if (!payload.onfItem.label && payload.onfItem.value) {
        message.warn("Please enter label.");
      }
      if (!payload.onfItem.value && payload.onfItem.label) {
        message.warn("Please enter value.");
      }
      if (payload.onfItem.label && payload.onfItem.value) {
        const getSelectedIndex = state.otherChecklistData.findIndex(
          (findItem) => findItem._id === payload.claItem._id
        );
        const updatedFields = [
          ...state.otherChecklistData[getSelectedIndex].checkListData,
        ];
        updatedFields.push({
          otherField: true,
          ...payload.onfItem,
          dataType: 2,
          _id: Math.random().toString(),
        });
        const updatedotherChecklistData = [...state.otherChecklistData];
        updatedotherChecklistData[getSelectedIndex] = {
          ...updatedotherChecklistData[getSelectedIndex],
          checkListData: updatedFields,
        };

        return {
          ...state,
          otherChecklistData: updatedotherChecklistData,
          otherFieldOfChecklist: [],
        };
      }
    },
    onClicRemoveOtherField: (state, { payload }) => {
      return {
        ...state,
        otherFieldOfChecklist: [],
      };
    },

    valueaddedonChange: (state, { payload }) => {
      const { extraindex, value, contractType, formId } = payload;

      const updatedFields = [...state.otherChecklistData];
      updatedFields[extraindex] = {
        ...updatedFields[extraindex],
        value,
        contractType,
        form: "extra",
        formId: formId,
      };

      return {
        ...state,
        otherChecklistData: updatedFields,
      };
    },
    setModalVisible: (state, { payload }) => {
      state.isVisible = payload.visible;
      state.importtype = payload?.type || "";
      state.editRecord = payload.record || {};
      state.extraRecord = payload.extraRecord || {};

      if (!payload.visible) {
        state.editRecord = {};
      }
    },
    setAddendumDrawerVisible: (state, { payload }) => {
      state.isAddendumDrawerVisible = payload.visible;
      state.editRecord = payload.record || {};
      console.log("payload", payload);
      if (payload.type === "edit" || payload.type === "view") {
        if (payload?.record?.dynamicParameters?.length > 0) {
          const extradata = payload?.record?.dynamicParameters.filter(
            (item) => item?.form === "extra"
          );
          const jsondata = payload?.record?.dynamicParameters.filter(
            (item) => item?.form !== "extra"
          );
          state.otherChecklistData = extradata.length > 0 ? extradata : [];
          state.jsonforvariables = jsondata.length > 0 ? jsondata : [];
        }

        state.jsonforvariables =
          payload?.record?.dynamicParameters || [];
        console.log(
          payload?.record?.dynamicParameters,
          "jsonforvariables"
        );
        state.templateforjsonData =
          payload?.record?.dynamicParameters?.length > 0
            ? {}
            : {};
        state.Generalextradetails = payload?.record?.parties?.extradetail || [];
      }
      state.jsonforvariables =
        payload?.record?.dynamicParameters?.length > 0
          ? payload?.record?.dynamicParameters
          : [];
      state.templateforjsonData =
        payload?.record?.dynamicParameters?.length > 0
          ? {}
          : {};
      state.Generalextradetails = payload?.record?.parties?.extradetail || [];
      state.type = payload.type || "";
      if (!payload.visible) {
        state.isVisible = false;
        state.editRecord = {};

        state.collapseDataIds = 0;
        state.historicalformdata = [];
        state.jsonforvariables = [];
        state.templateforjsonData = {};
        state.Generalextradetails = [];
        state.otherChecklistData = [];
        state.contractpdfurl = "";
        state.isHistoricalDetailViewVisible = false;
        // state.otherFieldOfChecklist = [];
      }
    },
    setPasswordmodal: (state, { payload }) => {
      state.ispasswordVisible = payload.visible;
      state.editRecord = payload?.record || {};
      if (!payload.visible) {
        state.editRecord = {};
      }
    },
    onPageChangesFilter: (state, action) => {
      state.historicalTaskPagination = {
        ...state.historicalTaskPagination,
        current: action.payload.current,
        pageSize: action.payload.pageSize,
        sortBy: action.payload.order === 1 ? "ASC" : "DESC",
        search: action.payload.search,
        orderBy: action.payload.orderBy,
      };
    },
    onPageChangesFilterforGroupbyId: (state, action) => {
      state.historicalTaskPaginationbygroupById = {
        ...state.historicalTaskPaginationbygroupById,
        current: action.payload.current,
        pageSize: action.payload.pageSize,
        sortBy: action.payload.order === 1 ? "ASC" : "DESC",
        search: action.payload.search,
        orderBy: action.payload.orderBy,
      };
    },
    onSearchList: (state, action) => {
      state.historicalTaskPagination = {
        ...state.historicalTaskPagination,
        search: action.payload.search || "",
      };
    },
    flowdatareset: (state, action) => {
      return initialState;
    },
    setDrawerVisible: (state, { payload }) => {
      state.isDrawerVisible = payload.visible;
      state.editRecord = payload.record || {};

      if (["edit", "editforLegal", "view"].includes(payload.type)) {
        if (payload?.record?.dynamicParameters?.length > 0) {
          const extradata = payload?.record?.dynamicParameters.filter(
            (item) => item?.form === "extra"
          );
          const jsondata = payload?.record?.dynamicParameters.filter(
            (item) => item?.form !== "extra"
          );

          state.otherChecklistData = extradata.length > 0 ? extradata : [];
          state.jsonforvariables = jsondata.length > 0 ? jsondata : [];
        }

        state.templateforjsonData =
          payload?.record?.dynamicParameters?.length > 0
            ? {}
            : {};
        state.Generalextradetails = payload?.record?.parties?.extradetail || [];
      }
      state.type = payload.type || "";
      if (!payload.visible) {
        state.isVisible = false;
        state.editRecord = {};
        state.isContentVisible = true;

        state.collapseDataIds = 0;
        state.historicalformdata = [];
        state.jsonforvariables = [];
        state.templateforjsonData = {};
        state.Generalextradetails = [];
        state.otherChecklistData = [];
        state.contractpdfurl = "";
        // state.otherFieldOfChecklist = [];
      }
    },
    setEditjsonModal: (state, { payload }) => {
      state.isEditjsonModalVisible = payload.visible;
      state.EditjsonModalRecord = payload.record || {};
      state.EditjsonModaltype = payload.type || "";
      if (!payload.visible) {
        state.EditcollapseIds = 0;

        // state.isVisible = false;
        // state.editRecord = {};
        // state.otherChecklistData = [];
        // state.otherFieldOfChecklist = [];
      }
    },
    changehistoricalLabelval: (state, { payload }) => {
      const { templateindex, value } = payload;
      const updatedFields = [...state.jsonforvariables];
      updatedFields[templateindex] = {
        ...updatedFields[templateindex],
        label: value,
      };

      return {
        ...state,
        jsonforvariables: updatedFields,
      };
    },
    changehistoricalGeneralLabelval: (state, { payload }) => {
      const { templateindex, value } = payload;
      const updatedFields = [...state.Generalextradetails];
      updatedFields[templateindex] = {
        ...updatedFields[templateindex],
        label: value,
      };

      return {
        ...state,
        Generalextradetails: updatedFields,
      };
    },
    changehistoricalExtraLabelval: (state, { payload }) => {
      const { templateindex, value } = payload;
      const updatedFields = [...state.otherChecklistData];
      updatedFields[templateindex] = {
        ...updatedFields[templateindex],
        label: value,
      };

      return {
        ...state,
        otherChecklistData: updatedFields,
      };
    },
    formjsonvalueaddedonChange: (state, { payload }) => {
      const { parentindex, childindex, value, subvalue } = payload;
      const updatedFields = [
        ...state.historicalformdata[parentindex]?.historicalTemplateFields,
      ];
      updatedFields[childindex] = {
        ...updatedFields[childindex],
        value,
        subvalue,
      };
      const updatedhistoricalformdata = [...state.historicalformdata];
      updatedhistoricalformdata[parentindex] = {
        ...updatedhistoricalformdata[parentindex],
        historicalTemplateFields: updatedFields,
      };
      return {
        ...state,
        historicalformdata: updatedhistoricalformdata,
      };
    },
    deletefieldfromjson: (state, { payload }) => {
      const { templateindex } = payload;
      state.jsonforvariables.splice(templateindex, 1);
    },
    deleteextrafielditemfromjson: (state, { payload }) => {
      const { parentindex, childindex } = payload;
      state.otherChecklistData[parentindex].checkListData.splice(childindex, 1);
    },
    Setnewfieldmodalvisible: (state, { payload }) => {
      state.isnewfieldModalVisible = payload.visible;
      state.fieldcreatefrom = payload?.createfrom || "";

      if (!payload.visible) {
        // state.isVisible = false;
        // state.editRecord = {};
        // state.otherChecklistData = [];
        // state.otherFieldOfChecklist = [];
      }
    },
    submitnewFielddata: (state, { payload }) => {
      if (state.fieldcreatefrom === "General") {
        state.Generalextradetails.push(...payload);
      } else if (state.fieldcreatefrom === "Extra") {
        state.otherChecklistData.push(...payload);
      } else {
        state.jsonforvariables.push(...payload);
      }
      state.isnewfieldModalVisible = false;
      //  state.otherChecklistData=[{...state.otherChecklistData,checkListData:...state.otherChecklistData.checkListData}]
      if (!payload.visible) {
        // state.isVisible = false;
        // state.editRecord = {};
        // state.otherChecklistData = [];
        // state.otherFieldOfChecklist = [];
      }
    },
    onChangehiscollapsePanel: (state, { payload }) => {
      state.collapseDataIds = payload;
    },
    setCompanydetails: (state, { payload }) => {
      state.Companydetails = payload;
    },
    onChangehisEditcollapseIdsPanel: (state, { payload }) => {
      state.EditcollapseIds = payload;
    },
    setTemplateselectedval: (state, { payload }) => {
      state.Templateselectedval = payload;
    },
    onTemplatevaluechanges: (state, { payload }) => {
      const { templateindex, value, contractType, UniqueId } = payload;
      const actualIndex = state.jsonforvariables.findIndex(
        (obj) => obj._id === UniqueId
      );
      const updatedFields = [...state.jsonforvariables];
      updatedFields[actualIndex] = {
        ...updatedFields[actualIndex],
        value,
        contractType,
      };

      return {
        ...state,
        jsonforvariables: updatedFields,
      };
    },
    onGeneralTemplatevaluechanges: (state, { payload }) => {
      const { templateindex, value, contractType } = payload;
      const updatedFields = [...state.Generalextradetails];
      updatedFields[templateindex] = {
        ...updatedFields[templateindex],
        value,
        contractType,
      };

      return {
        ...state,
        Generalextradetails: updatedFields,
      };
    },
    deletefieldfromGeneraljson: (state, { payload }) => {
      const { templateindex } = payload;
      state.Generalextradetails.splice(templateindex, 1);
    },
    deletefieldfromExtrajson: (state, { payload }) => {
      const { extraindex } = payload;
      state.otherChecklistData.splice(extraindex, 1);
    },
    getHistoricalfilterActive: (state, { payload }) => {
      state.isFilterApplied = payload;
    },
    filterpopoverhandleOpenChange: (state, { payload }) => {
      state.isFiltermodalopen = payload;
    },
    filterchangepagination: (state, { payload }) => {
      if (Object.keys(payload).length === 0) {
        state.historicalTaskPagination = {
          ...initialState.historicalTaskPagination,
        };
      } else {
        state.historicalTaskPagination = {
          ...state.historicalTaskPagination,
          ...payload,
        };
      }
    },
    makelifecyclefieldrequiredvalChange: (state, { payload }) => {
      const { lifecycleFieldIndex, required, value } = payload;
      const updatedFields = [...state.jsonforvariables];
      updatedFields[lifecycleFieldIndex] = {
        ...updatedFields[lifecycleFieldIndex],

        required: required,
        value: value ? value : updatedFields[lifecycleFieldIndex].value,
      };

      return {
        ...state,
        jsonforvariables: updatedFields,
      };
      // state.jsonforvariables.splice(templateindex, 1);
    },
    setcontractpdfurl: (state, { payload }) => {
      state.contractpdfurl = "";
    },
    setHistoricalDetailViewVisible: (state, { payload }) => {
      state.isHistoricalDetailViewVisible = payload?.visible;
      state.editRecord = payload?.record || {};
      if (!payload?.visible) {
        state.contractpdfurl = "";
        state.editRecord = {};
        state.jsonforvariables = [];
      }
    },
    setbulkLegacyImportVisible: (state, { payload }) => {
      state.isBulkLegacyImportVisible = payload.visible;
      state.parentContractDetail = payload?.record || {};
    },
    setMetadataInfoModalVisible: (state, { payload }) => {
      state.isMetadataInfoModalVisible = payload.visible;
    },
    setImportInfobygroupId: (state, { payload }) => {
      state.groupIdInfo = payload;
    },
    setCheckBulkUploadModalVisible: (state, { payload }) => {
      state.isCheckBulkUploadModalVisible = payload?.visible;
      state.BulkuploadRecord = payload?.record || {};
    },
    onPageChangesFilterofImport: (state, { payload }) => {
      state.ImportListPagiantion = {
        ...state.ImportListPagiantion,
        current: payload.current,
        pageSize: payload.size,
      };
    },
    setTasktoLegalAssociateModalVisible: (state, { payload }) => {
      state.isLegalAssociateModalVisible = payload.visible;

      if (!payload.visible) {
        state.ImportsItemByIdLists = [];
        state.groupIdInfo = {};
        state.selectedTasksIds = [];
      }
    },
    setAssignandReassignModalVisible: (state, { payload }) => {
      state.isAssignandReassignModalVisible = payload.visible || false;
      state.assignModalType = payload.type || "";
      state.assignModalRecord = payload.record || {};

      if (!payload.visible) {
        state.assignModalRecord = {};
        state.assignModalType = "";
      }
    },
    setAssignandReassignFilterModalVisible: (state, { payload }) => {
      state.isAssignandReassignFilterModalVisible = payload.visible || false;

      if (!payload.visible) {
      }
    },
    setSelectedTasksIds: (state, { payload }) => {
      state.selectedTasksIds = payload;
    },
    setAssignFilterApplied: (state, { payload }) => {
      state.isAssignFilterApplied = payload;
    },
    setAssigndFilterPaginationData: (state, { payload }) => {
      state.AssigndFilterPaginationData = payload;
    },
    onPageChangesFilterofImportsById: (state, { payload }) => {
      state.ImportsItemByIdListsPagination = {
        ...state.ImportsItemByIdListsPagination,
        current: payload.current,
        pageSize: payload.size,
      };
    },
    setBulkAssignModalVisible: (state, { payload }) => {
      state.isBulkAssignModalVisible = payload.visible || false;

      if (!payload.visible) {
      }
    },
    setAIpromptModalVisible: (state, { payload }) => {
      state.isAIpromptModalVisible = payload.visible;
      state.promptRecord = payload?.record || "";
    },
    setEditpromptModalVisible: (state, { payload }) => {
      state.isEditPromptModalVisible = payload?.visible;
    },
    changehistoricalinfo: (state, { payload }) => {
      const { index, value } = payload;
      const updatedFields = [...state.jsonforvariables];
      updatedFields[index] = {
        ...updatedFields[index],
        info: value,
      };

      return {
        ...state,
        jsonforvariables: updatedFields,
      };
    },
    setFindMissingContractModalVisible: (state, { payload }) => {
      state.isFindMissingcontractModalVisible = payload?.visible;
      state.isFindMissingContractRecord = payload?.record || {};
    },
    setAIprocessingModal: (state, { payload }) => {
      state.isAIprocessingModalVisible = payload?.visible;
    },
    setRemoveDuplicatesModalVisible: (state, { payload }) => {
      state.isRemoveDuplicatesModalVisible = payload?.visible;
    },
    setAIreferenceDrawerVisible: (state, { payload }) => {
      state.isAIreferenceDrawerVisible = payload?.visible;
      state.isAIreferenceRecord = payload?.record || {};
    },
    setImportAddendumVisible: (state, { payload }) => {
      state.isImportAddendumVisible = payload?.visible || false;
      state.importAddendumRecord = payload?.record || {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTaskdetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTaskdetails.fulfilled, (state, { payload }) => {
        state.historicalTaskList = payload.data;
        state.isHistoricalDatinlimit =
          payload?.licenseQuota?.historicalContract;
        state.isLoading = false;
        state.totalCount = payload.totalCount;
        state.historicalTaskPagination = {
          ...state.historicalTaskPagination,
          total: payload.total,
        };
        // state.groupIdInfo = {};
      })
      .addCase(getTaskdetails.rejected, (state, { payload }) => {
        state.isLoading = false;
      })
      .addCase(historicalFlowCreate.pending, (state) => {
        state.isCreateLoading = true;
      })
      .addCase(historicalFlowCreate.fulfilled, (state, { payload }) => {
        state.isCreateLoading = false;
        state.isSuccess = true;

        state.otherChecklistData = [];

        state.collapseDataIds = 0;
        state.historicalformdata = [];
        state.editRecord = {};
        state.isDrawerVisible = false;
        state.isVisible = false;
        state.Generalextradetails = [];
        // ResponseMessageHandler()
      })
      .addCase(historicalFlowCreate.rejected, (state) => {
        state.isCreateLoading = false;
      })

      .addCase(updatehistoricalFlow.pending, (state) => {
        state.isCreateLoading = true;
      })
      .addCase(updatehistoricalFlow.fulfilled, (state, { payload }) => {
        state.isCreateLoading = false;
        state.isSuccess = true;
        state.isVisible = false;

        // ResponseMessageHandler()
      })
      .addCase(updatehistoricalFlow.rejected, (state, { payload }) => {
        state.isCreateLoading = false;
      })
      .addCase(deleteTask.pending, (state, { payload }) => {
        //conditions
        // ResponseMessageHandler()
      })
      .addCase(deleteTask.fulfilled, (state, { payload }) => {
        //conditions
      })
      .addCase(deleteTask.rejected, (state, { payload }) => {
        //conditions
      })
      .addCase(Resetpassword.pending, (state, { payload }) => {
        state.ispasswordloading = true;
      })
      .addCase(Resetpassword.fulfilled, (state, { payload }) => {
        state.ispasswordVisible = false;
        state.ispasswordloading = false;
        state.ispasswordupdated = true;
      })
      .addCase(Resetpassword.rejected, (state, { payload }) => {
        state.ispasswordloading = false;
      })
      .addCase(getHistoricaljsondata.pending, (state, { payload }) => {
        // state.ispasswordloading = true;
      })
      .addCase(getHistoricaljsondata.fulfilled, (state, { payload }) => {
        state.jsonforvariables = payload?.data || [];
        state.templateforjsonData =
          payload?.data?.length > 0 ? { fields: payload?.data } : {};
      })
      .addCase(getHistoricaljsondata.rejected, (state, { payload }) => {
        // state.ispasswordloading = false;
      })
      .addCase(
        updateHistoricaljsondefaultdata.pending,
        (state, { payload }) => {
          // state.ispasswordloading = true;
        }
      )
      .addCase(
        updateHistoricaljsondefaultdata.fulfilled,
        (state, { payload }) => {
          state.isEditjsonModalVisible = false;
        }
      )
      .addCase(
        updateHistoricaljsondefaultdata.rejected,
        (state, { payload }) => {
          // state.ispasswordloading = false;
        }
      )
      .addCase(CreatehistoricalContracts.pending, (state, { payload }) => {
        state.isCreateLoading = true;
      })
      .addCase(CreatehistoricalContracts.fulfilled, (state, { payload }) => {
        state.jsonforvariables = [];
        state.templateforjsonData = {};
        state.isDrawerVisible = false;
        state.isVisible = false;
        state.isCreateLoading = false;
        state.Generalextradetails = [];
        state.otherChecklistData = [];
        state.collapseDataIds = 0;
      })
      .addCase(CreatehistoricalContracts.rejected, (state, { payload }) => {
        // state.ispasswordloading = false;
        state.isCreateLoading = false;
      })
      .addCase(GetbufferdatafromUrl.pending, (state, { payload }) => {
        state.contractpdfurl = "";
      })
      .addCase(GetbufferdatafromUrl.fulfilled, (state, { payload }) => {
        state.contractpdfurl = payload;
      })
      .addCase(GetbufferdatafromUrl.rejected, (state, { payload }) => {
        state.contractpdfurl = "";
      })
      .addCase(
        CreatehistoricalContractsAddendum.pending,
        (state, { payload }) => {
          state.isCreateLoading = true;
        }
      )
      .addCase(
        CreatehistoricalContractsAddendum.fulfilled,
        (state, { payload }) => {
          state.jsonforvariables = [];
          state.templateforjsonData = {};
          state.isAddendumDrawerVisible = false;
          state.isVisible = false;
          state.isCreateLoading = false;
          state.Generalextradetails = [];
          state.otherChecklistData = [];
          state.collapseDataIds = 0;
          if (state.type === "edit") {
            state.editRecord = payload?.data;
          }
        }
      )
      .addCase(
        CreatehistoricalContractsAddendum.rejected,
        (state, { payload }) => {
          // state.ispasswordloading = false;
          state.isCreateLoading = false;
        }
      )
      .addCase(getHistoricalDatabyId.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHistoricalDatabyId.fulfilled, (state, { payload }) => {
        // state.isAddendumDrawerVisible = true;
        // state.type = "edit";
        state.isLoading = false;

        state.editRecord = payload?.data?.length > 0 ? payload.data[0] : {};
      })
      .addCase(getHistoricalDatabyId.rejected, (state, { payload }) => {
        state.isLoading = false;
      })
      .addCase(getImportsList.pending, (state) => {
        state.ImportListsLoading = false;
      })
      .addCase(getImportsList.fulfilled, (state, { payload }) => {
        state.ImportListsLoading = true;
        state.ImportLists = payload?.data;
        state.ImportListPagiantion = {
          ...state.ImportListPagiantion,
          total: payload?.total,
        };
      })
      .addCase(getImportsList.rejected, (state, { payload }) => {
        state.ImportListsLoading = false;
      })
      .addCase(getImportItemById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getImportItemById.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.historicalTaskList = payload?.data;
        // state.totalCount = payload.data?.length;
        state.historicalTaskPaginationbygroupById = {
          ...state.historicalTaskPaginationbygroupById,
          total: payload?.total,
        };
      })
      .addCase(getImportItemById.rejected, (state, { payload }) => {
        state.isLoading = false;
      })
      .addCase(CreateBulkHistorical.pending, (state) => {
        state.isBulkpdupLoading = true;
      })
      .addCase(CreateBulkHistorical.fulfilled, (state, { payload }) => {
        state.isBulkpdupLoading = false;
      })
      .addCase(CreateBulkHistorical.rejected, (state, { payload }) => {
        state.isBulkpdupLoading = false;
      })
      .addCase(submitFileUploadExcel.pending, (state) => {
        state.isBulkjsonupLoading = true;
      })
      .addCase(submitFileUploadExcel.fulfilled, (state, { payload }) => {
        state.isBulkjsonupLoading = false;
        state.isCheckBulkUploadModalVisible = false;
        state.isMetadataInfoModalVisible = false;
      })
      .addCase(submitFileUploadExcel.rejected, (state, { payload }) => {
        state.isBulkjsonupLoading = false;
      })
      .addCase(getTokenforGoogledrive.pending, (state) => {})
      .addCase(getTokenforGoogledrive.fulfilled, (state, { payload }) => {
        state.googleDriveData = payload?.data;
      })
      .addCase(getTokenforGoogledrive.rejected, (state, { payload }) => {})
      .addCase(Sendfilesandfolder.pending, (state) => {
        state.isBulkpdupLoading = true;
      })
      .addCase(Sendfilesandfolder.fulfilled, (state, { payload }) => {
        state.isBulkLegacyImportVisible = false;
        state.googleDriveData = {};
        state.isBulkpdupLoading = false;
      })
      .addCase(Sendfilesandfolder.rejected, (state, { payload }) => {
        state.isBulkpdupLoading = false;
      })
      .addCase(getLegalAssociates.pending, (state) => {
        state.isLegalAssociatesLoading = true;
      })
      .addCase(getLegalAssociates.fulfilled, (state, { payload }) => {
        state.isLegalAssociatesLoading = false;
        state.legalAssociatesList = payload.data;
      })
      .addCase(getLegalAssociates.rejected, (state, { payload }) => {
        state.isLegalAssociatesLoading = false;
      })
      .addCase(getAssignTasktoLegalAssociates.pending, (state) => {
        state.isAssignTasktoLegalAssociatesLoading = true;
      })
      .addCase(
        getAssignTasktoLegalAssociates.fulfilled,
        (state, { payload }) => {
          state.isAssignTasktoLegalAssociatesLoading = false;
          state.isAssignandReassignModalVisible = false;
          state.selectedTasksIds = [];
        }
      )
      .addCase(
        getAssignTasktoLegalAssociates.rejected,
        (state, { payload }) => {
          state.isAssignTasktoLegalAssociatesLoading = false;
        }
      )
      .addCase(getReAssignTasktoLegalAssociates.pending, (state) => {
        state.isReAssignTasktoLegalAssociatesLoading = true;
      })
      .addCase(
        getReAssignTasktoLegalAssociates.fulfilled,
        (state, { payload }) => {
          state.isReAssignTasktoLegalAssociatesLoading = false;
        }
      )
      .addCase(
        getReAssignTasktoLegalAssociates.rejected,
        (state, { payload }) => {
          state.isReAssignTasktoLegalAssociatesLoading = false;
        }
      )
      .addCase(getAllImportsItemById.pending, (state) => {
        state.isImportsItemByLoading = true;
      })
      .addCase(getAllImportsItemById.fulfilled, (state, { payload }) => {
        state.isImportsItemByLoading = false;
        state.ImportsItemByIdLists = payload.data;
        state.ImportsItemByIdListsPagination = {
          ...state.ImportsItemByIdListsPagination,
          total: payload?.total,
        };
      })
      .addCase(getAllImportsItemById.rejected, (state, { payload }) => {
        state.isImportsItemByLoading = false;
      })
      .addCase(getDistributedcontractDetails.pending, (state) => {
        // state.isImportsItemByLoading = true;
      })
      .addCase(
        getDistributedcontractDetails.fulfilled,
        (state, { payload }) => {
          state.distributedContractDetails = payload || {};
        }
      )
      .addCase(getDistributedcontractDetails.rejected, (state, { payload }) => {
        // state.isImportsItemByLoading = false;
      })
      .addCase(unassignandReassignContractToLegalAssociate.pending, (state) => {
        state.isAssignTasktoLegalAssociatesLoading = true;
      })
      .addCase(
        unassignandReassignContractToLegalAssociate.fulfilled,
        (state, { payload }) => {
          state.isAssignTasktoLegalAssociatesLoading = false;

          state.isAssignandReassignModalVisible = false;
        }
      )
      .addCase(
        unassignandReassignContractToLegalAssociate.rejected,
        (state, { payload }) => {
          state.isAssignTasktoLegalAssociatesLoading = false;
        }
      )
      .addCase(getDetailsFillwithAI.pending, (state) => {
        // state.isDrawerVisible = false;
        state.isContentVisible = false;
      })
      .addCase(getDetailsFillwithAI.fulfilled, (state, { payload }) => {
        state.isContentVisible = true;

        state.isDrawerVisible = true;
        state.editRecord = payload?.data?.historicalContractDetails || {};
        if (
          payload?.data?.historicalContractDetails?.dynamicParameters?.length > 0
        ) {
          const extradata =
            payload?.data?.historicalContractDetails?.dynamicParameters.filter(
              (item) => item?.form === "extra"
            );
          const jsondata =
            payload?.data?.historicalContractDetails?.dynamicParameters.filter(
              (item) => item?.form !== "extra"
            );
          state.otherChecklistData = extradata.length > 0 ? extradata : [];
          state.jsonforvariables = jsondata.length > 0 ? jsondata : [];
        }

        state.templateforjsonData =
          payload?.data?.historicalContractDetails?.dynamicParameters?.length > 0
            ? {}
            : {};
        state.Generalextradetails =
          payload?.data?.historicalContractDetails?.parties?.extradetail || [];
        state.type = "edit";
      })
      .addCase(getDetailsFillwithAI.rejected, (state, { payload }) => {
        state.isContentVisible = true;
      })
      .addCase(getAddendumDetailsFillwithAI.pending, (state) => {
        // state.isDrawerVisible = false;
        state.isContentVisible = false;
      })
      .addCase(getAddendumDetailsFillwithAI.fulfilled, (state, { payload }) => {
        state.isContentVisible = true;

        state.isAddendumDrawerVisible = true;
        state.editRecord = payload?.data?.historicalContractDetails || {};
        if (
          payload?.data?.historicalContractDetails?.dynamicParameters?.length > 0
        ) {
          const extradata =
            payload?.data?.historicalContractDetails?.dynamicParameters.filter(
              (item) => item?.form === "extra"
            );
          const jsondata =
            payload?.data?.historicalContractDetails?.dynamicParameters.filter(
              (item) => item?.form !== "extra"
            );
          state.otherChecklistData = extradata.length > 0 ? extradata : [];
          state.jsonforvariables = jsondata.length > 0 ? jsondata : [];
        }

        state.templateforjsonData =
          payload?.data?.historicalContractDetails?.dynamicParameters?.length > 0
            ? {}
            : {};
        state.Generalextradetails =
          payload?.data?.historicalContractDetails?.parties?.extradetail || [];
        state.type = "edit";
      })
      .addCase(getAddendumDetailsFillwithAI.rejected, (state, { payload }) => {
        state.isContentVisible = true;
      })
      .addCase(saveCompanyPrompt.pending, (state) => {
        state.isAIpromptSubmitting = true;
      })
      .addCase(saveCompanyPrompt.fulfilled, (state, { payload }) => {
        state.isAIpromptSubmitting = false;
        state.isAIpromptModalVisible = false;
        state.groupIdInfo = payload?.data || {};
      })
      .addCase(saveCompanyPrompt.rejected, (state, { payload }) => {
        state.isAIpromptSubmitting = false;
      })
      .addCase(getBulkAssignedData.pending, (state) => {})
      .addCase(getBulkAssignedData.fulfilled, (state, { payload }) => {
        state.BulkAssignedData = payload.data;
      })
      .addCase(getBulkAssignedData.rejected, (state, { payload }) => {})
      .addCase(getBulkAssignTasktoLegalAssociates.pending, (state) => {
        state.isBulkAssigningTask = true;
      })
      .addCase(
        getBulkAssignTasktoLegalAssociates.fulfilled,
        (state, { payload }) => {
          state.isBulkAssigningTask = false;
          state.isBulkAssignModalVisible = false;
        }
      )
      .addCase(
        getBulkAssignTasktoLegalAssociates.rejected,
        (state, { payload }) => {
          state.isBulkAssigningTask = false;
        }
      )
      .addCase(getBulkReAssignTasktoLegalAssociates.pending, (state) => {
        state.isBulkAssigningTask = true;
      })
      .addCase(
        getBulkReAssignTasktoLegalAssociates.fulfilled,
        (state, { payload }) => {
          state.isBulkAssigningTask = false;
          state.isBulkAssignModalVisible = false;
        }
      )
      .addCase(
        getBulkReAssignTasktoLegalAssociates.rejected,
        (state, { payload }) => {
          state.isBulkAssigningTask = false;
        }
      )
      .addCase(EditPrompt.pending, (state) => {
        state.isEditingprompt = true;
      })
      .addCase(EditPrompt.fulfilled, (state, { payload }) => {
        state.isEditingprompt = false;
        state.isEditPromptModalVisible = false;
        state.jsonforvariables = payload.data?.dynamicParameters || [];
      })
      .addCase(EditPrompt.rejected, (state, { payload }) => {
        state.isEditingprompt = false;
      })
      .addCase(FindMissingContract.pending, (state) => {
        state.isFindingMissingcontract = true;
        // state.isFindMissingcontractModalVisible = true;
      })
      .addCase(FindMissingContract.fulfilled, (state, { payload }) => {
        // state.isFindMissingcontractModalVisible = true;
        // state.isFindingMissingcontract = false;
      })
      .addCase(FindMissingContract.rejected, (state, { payload }) => {
        state.isFindMissingcontractModalVisible = false;

        state.isFindingMissingcontract = false;
      })
      .addCase(getImportsDetailsById.pending, (state) => {})
      .addCase(getImportsDetailsById.fulfilled, (state, { payload }) => {
        state.groupIdInfo = payload?.data || {};
      })
      .addCase(getImportsDetailsById.rejected, (state, { payload }) => {})
      .addCase(findDuplicatesContract.pending, (state) => {
        state.isFindingDuplicatesContract = true;
      })
      .addCase(findDuplicatesContract.fulfilled, (state, { payload }) => {
        state.isFindingDuplicatesContract = false;
      })
      .addCase(findDuplicatesContract.rejected, (state, { payload }) => {
        state.isFindingDuplicatesContract = false;
      })
      .addCase(getDuplicatesContractLists.pending, (state) => {
        state.isDuplicateContractsLoading = true;
      })
      .addCase(getDuplicatesContractLists.fulfilled, (state, { payload }) => {
        state.isDuplicateContractsLoading = false;
        state.duplicateContractsLists = payload?.data || [];
      })
      .addCase(getDuplicatesContractLists.rejected, (state, { payload }) => {
        state.isDuplicateContractsLoading = false;
      })
      .addCase(deleteDuplicatesContracts.pending, (state) => {
        state.isDeletingDuplicates = true;
      })
      .addCase(deleteDuplicatesContracts.fulfilled, (state, { payload }) => {
        state.isDeletingDuplicates = false;
        state.isRemoveDuplicatesModalVisible = false;
      })
      .addCase(deleteDuplicatesContracts.rejected, (state, { payload }) => {
        state.isDeletingDuplicates = false;
      })
      .addCase(getHistoricalDetails.pending, (state) => {
        state.isHistoricalDetailsLoading = true;
      })
      .addCase(getHistoricalDetails.fulfilled, (state, { payload }) => {
        state.isHistoricalDetailsLoading = false;

        state.editRecord = payload?.data;

        if (payload?.data?.dynamicParameters?.length > 0) {
          const extradata = payload?.data?.dynamicParameters.filter(
            (item) => item?.form === "extra"
          );
          const jsondata = payload?.data?.dynamicParameters.filter(
            (item) => item?.form !== "extra"
          );

          state.otherChecklistData = extradata.length > 0 ? extradata : [];
          state.jsonforvariables = jsondata.length > 0 ? jsondata : [];
        }

        state.templateforjsonData =
          payload?.data?.dynamicParameters?.length > 0
            ? {}
            : {};
        state.Generalextradetails = payload?.data?.parties?.extradetail || [];
      })
      .addCase(getHistoricalDetails.rejected, (state, { payload }) => {
        state.isHistoricalDetailsLoading = false;
      })
      .addCase(ImportAddendumforHistorical.pending, (state) => {
        state.isAddendumImportingForHistorical = true;
      })
      .addCase(ImportAddendumforHistorical.fulfilled, (state, { payload }) => {
        state.isAddendumImportingForHistorical = false;
        state.isImportAddendumVisible = false;
        state.importAddendumRecord = {};
      })
      .addCase(ImportAddendumforHistorical.rejected, (state, { payload }) => {
        state.isAddendumImportingForHistorical = false;
      });
  },
});
export const {
  setModalVisible,
  onPageChangesFilter,
  flowdatareset,
  onSearchList,
  setPasswordmodal,
  setDrawerVisible,
  onChangeOtherData,
  valueaddedonChange,
  onClickAddOtherField,

  onChangeNewKeyTitle,
  onChangeNewvalueTitle,
  onClickAddnewOtherFieldInObject,
  onClicRemoveOtherField,
  setEditjsonModal,
  changehistoricalLabelval,
  formjsonvalueaddedonChange,
  Setnewfieldmodalvisible,
  submitnewFielddata,
  onChangehiscollapsePanel,
  setCompanydetails,
  deletefieldfromjson,
  onChangehisEditcollapseIdsPanel,
  deleteextrafielditemfromjson,
  setTemplateselectedval,
  onTemplatevaluechanges,
  onGeneralTemplatevaluechanges,
  deletefieldfromGeneraljson,
  deletefieldfromExtrajson,
  changehistoricalExtraLabelval,
  changehistoricalGeneralLabelval,
  getHistoricalfilterActive,
  filterpopoverhandleOpenChange,
  filterchangepagination,
  makelifecyclefieldrequiredvalChange,
  setcontractpdfurl,
  setAddendumDrawerVisible,
  setHistoricalDetailViewVisible,
  setbulkLegacyImportVisible,
  setMetadataInfoModalVisible,
  setImportInfobygroupId,
  setCheckBulkUploadModalVisible,
  onPageChangesFilterforGroupbyId,
  onPageChangesFilterofImport,
  setTasktoLegalAssociateModalVisible,
  setAssignandReassignModalVisible,
  setAssignandReassignFilterModalVisible,
  setSelectedTasksIds,
  setAssignFilterApplied,
  setAssigndFilterPaginationData,
  onPageChangesFilterofImportsById,
  setBulkAssignModalVisible,
  setAIpromptModalVisible,
  setEditpromptModalVisible,
  changehistoricalinfo,
  setFindMissingContractModalVisible,
  setAIprocessingModal,
  setRemoveDuplicatesModalVisible,
  setAIreferenceDrawerVisible,
  setImportAddendumVisible,
} = flowSlice.actions;

export default flowSlice.reducer;
